import React, { useEffect } from "react";
import Html from "utils/Html";
import Func from "utils/Func";
import { Dropdown } from "semantic-ui-react";
import { useNotify } from "context/NotifyContext";

export default function FilterCountry({ data }) {
  const { filters, storeFilters } = useNotify();
  const filterName = "country";
  const filterTitle = "Country";
  let handleEvents = {
    SelectNone: {
      OnClick: function (evt) {
        let selectedArr = [];
        // console.log("Btn Select None => " + filterName);
        storeFilters({
          ...filters,
          country: selectedArr,
          // key_form: Func.GetKeyRandom(),
          keyChange: Func.GetKeyRandom(),
        });
      },
    },
    SelectAll: {
      OnClick: function (evt) {
        let selectedArr = [];
        for (const i in data) {
          selectedArr.push(data[i].code);
        }
        // console.log("Btn Select All => " + filterName, selectedArr);
        storeFilters({
          ...filters,
          country: selectedArr,
          keyChange: Func.GetKeyRandom(),
        });
      },
    },
    OnChange: function (evt, { name, value }) {
      storeFilters({
        ...filters,
        country: value,
        keyChange: Func.GetKeyRandom(),
      });
    },
  };
  useEffect(() => {}, []);
  return (
    <div
      key={"filter-" + filterName + "-" + filters.key_form}
      className="filter-input-field select"
    >
      <Html.SelectAll handleEvents={handleEvents} />
      <label htmlFor={"filter-inp-" + filterName} className="label">
        {filterTitle}
      </label>
      <Dropdown
        fluid
        selection
        search={true}
        multiple={true}
        id={"filter-inp-" + filterName}
        name={filterName}
        placeholder={filterTitle}
        options={Html.OptionList(data, {
          id: "",
          key: filterName,
          name: "name",
          value: "name",
          optionGroup: false,
          optionNull: false,
        })}
        value={filters?.country ?? []}
        onChange={handleEvents.OnChange}
        disabled={false}
      />
      <span
        className="select-helper-text hide"
        id={"helper-text-" + filterName}
      >
        {"Please select " + filterName}
      </span>
    </div>
  );
}
